<div class="settings-sidebar">
  <!-- Mobile Header -->
  <app-mobile-detail-header title="Setting" (back)="goBack()"></app-mobile-detail-header>

  <!-- Desktop Header -->
  <div class="settings-header desktop-header">
    <a routerLink="/home" class="back-button">
      <i class="pi pi-arrow-left"></i>
      <span>Back</span>
    </a>
    <h1 class="settings-title">Setting</h1>
  </div>

  <nav class="settings-menu">
    <ng-container *ngIf="menuItems$ | async as menuItems">
      <a *ngFor="let item of menuItems" [routerLink]="item.route" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }" class="menu-item" (click)="onMenuClick()">
        <div class="menu-item-left">
          <app-svg-loader [url]="item.icon" class="menu-icon"></app-svg-loader>
          <span class="menu-label">{{ item.label }}</span>
        </div>
        <i class="pi pi-chevron-right mobile-chevron"></i>
      </a>
    </ng-container>
  </nav>
</div>